const styles = () => ({
  maxWidth: 600,
  margin: '0 auto',
  width: '100%',
});
export default styles;
